import sal from "sal.js"; // github.com/mciastek/sal
import axios from 'axios';
import mustache from "mustache";

window.glob = {
    axios,
    mustache,
    sal
}
